import { assertThisInitialized as _assertThisInitialized } from "\0rollupPluginModLoBabelHelpers.js";
import { inheritsLoose as _inheritsLoose } from "\0rollupPluginModLoBabelHelpers.js";
import { defineProperty as _defineProperty } from "\0rollupPluginModLoBabelHelpers.js";

var _dec, _class, _temp;

import { cclegacy as _cclegacy } from "cc";

_cclegacy._RF.push({}, "53784CCGXhPpp3++cv7c0PJ", "NumShake", undefined);

// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html
import { _decorator, Component, v2, Vec2, v3 } from "cc";
var ccclass = _decorator.ccclass,
    property = _decorator.property,
    menu = _decorator.menu;
var NumShake = (_dec = menu("act/NumShake"), ccclass(_class = _dec(_class = (_temp = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NumShake, _Component);

  function NumShake() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_shakeTime", 0.5);

    _defineProperty(_assertThisInitialized(_this), "_shakeReduce", 0.1);

    _defineProperty(_assertThisInitialized(_this), "_shakeBaseRange", 8);

    _defineProperty(_assertThisInitialized(_this), "_curShakeRange", 0);

    _defineProperty(_assertThisInitialized(_this), "_aimScale", 1.5);

    _defineProperty(_assertThisInitialized(_this), "_scaleReduce", 0.01);

    _defineProperty(_assertThisInitialized(_this), "_initPos", new Vec2());

    return _this;
  }

  var _proto = NumShake.prototype;

  // LIFE-CYCLE CALLBACKS:
  _proto.onLoad = function onLoad() {
    this._initPos = v2(this.node.position.x, this.node.position.y);
  };

  _proto.start = function start() {};

  _proto.shake = function shake() {
    this._shakeTime = 1;
    this._curShakeRange = this._shakeBaseRange;
    this.node.scale = v3(this._aimScale, this._aimScale);
  };

  _proto.update = function update(dt) {
    if (this._shakeTime > 0) {
      this._shakeTime -= dt;
      var minNum = this._curShakeRange - 1 > 0 ? this._curShakeRange - 1 : 0;
      var x_aim = this._initPos.x + Math.random() * this._curShakeRange + minNum;
      var y_aim = this._initPos.y + Math.random() * this._curShakeRange + minNum;
      this.node.setPosition(v3(x_aim, y_aim));
      this._curShakeRange -= this._shakeReduce;

      if (this.node.scale.x <= 1) {
        this.node.scale = v3(1, 1);
      } else {
        this.node.scale = v3(this.node.scale).subtract(v3(this._scaleReduce, this._scaleReduce));
      }
    } else {
      this.node.setPosition(v3(this._initPos.x, this._initPos.y));
    }
  };

  return NumShake;
}(Component), _temp)) || _class) || _class);
export { NumShake as default };

_cclegacy._RF.pop();